export function track(type, label) {
  try {
    const payload = JSON.stringify({ type, label });
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/track`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
    } else {
      fetch(url, { method: "POST", body: payload, headers: { "Content-Type": "application/json" }, keepalive: true });
    }
  } catch (e) {
    /* tracking must never break the page */
  }
}